var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.$attrs.type,_vm._b({tag:"component"},'component',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }